var exports = {
  "i": "xaee3c4fa--d088db--wrapper",
};

module.exports = exports;
